import {createContext,useContext} from 'react'
import type {CrmCapability,CrmRole} from './crmRbac'

export type CrmIdentity={
 userId:string
 workspaceId:string
 role:CrmRole
 capabilities:readonly CrmCapability[]
 profile:{firstName:string;lastName:string;email:string;department:string;jobTitle:string}
 displayName:string
 initials:string
 mustChangePassword:boolean
}

const CrmIdentityContext=createContext<CrmIdentity|null>(null)
export const CrmIdentityProvider=CrmIdentityContext.Provider
export function useCrmIdentity(){const value=useContext(CrmIdentityContext);if(!value)throw new Error('canonical_crm_identity_required');return value}
